// Shared header for player-side game control screens.

import React from 'react';

interface PlayingScreenHeaderProps {
  title: string;
  description?: string;
}

const PlayingScreenHeader: React.FC<PlayingScreenHeaderProps> = ({
  title,
  description,
}) => {
  return (
    <header className="mb-1 flex shrink-0 flex-col gap-1.5 px-1 pb-2 text-center">
      <h2 className="font-heading text-xl font-semibold text-foreground">
        {title}
      </h2>
      {description && (
        <p className="text-sm leading-snug text-muted-foreground">
          {description}
        </p>
      )}
    </header>
  );
};

export default PlayingScreenHeader;
